import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: '100%',
    margin: 0,
  },
  paper: {
    boxShadow: '0px 3px 6px #0000001A',
    textAlign: 'center',
    padding: '0',
  },
  tabContent: {},
  customRootClass: {
    boxShadow: 'none',
  },
  tab: {
    padding: '25px 35px 20px',
  },
  description: {
    lineHeight: 1,
    marginTop: 25,
    marginBottom: 15,
  },
  stepperContainer: {
    margin: '0 auto',
    maxWidth: 700,
  },
  activeStatus: {
    color: theme.palette.success.main,
    textTransform: 'capitalize',

    '&::first-letter': {
      textTransform: 'uppercase',
    },
  },
}));

export default useStyles;
